import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

import { regions } from '../constants/regions'

// 根据环境自动设置默认 region
function getDefaultRegionKey(): string {
  const env = import.meta.env.VITE_ENV
  if (env === 'prod') {
    return 'us' // 生产环境默认美国
  }
  else if (env === 'test') {
    return 'test' // 测试环境默认测试
  }
  else {
    return 'dev' // 开发环境默认开发
  }
}

export const useRegionStore = defineStore('region', () => {
  const defaultRegionKey = getDefaultRegionKey()
  // 确保默认值在过滤后的 regions 中存在，否则使用第一个可用的 region
  const validDefaultKey = regions.find(r => r.envKey === defaultRegionKey)?.envKey || regions[0]?.envKey || 'dev'
  const currentRegionKey = ref(validDefaultKey)

  const currentRegion = computed(() => {
    return regions.find(region => region.envKey === currentRegionKey.value) || regions[0]
  })

  const setRegion = (regionKey: string) => {
    const region = regions.find(r => r.envKey === regionKey)
    if (region) {
      currentRegionKey.value = regionKey
    }
  }

  const getRegionByKey = (regionKey: string) => {
    return regions.find(region => region.envKey === regionKey)
  }

  return {
    currentRegion,
    currentRegionKey,
    regions,
    setRegion,
    getRegionByKey,
  }
})
